<!-- 项目中心首页 -->
<template>
  <div
    class="project_center"
    v-loading="loading"
    element-loading-text="loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0)"
  >
    <!-- 根据项目职务权限不同 -->
    <div class="candidates_flex">
      <div @click="leftproject" :class="typeindex == 0 ? 'left_active' : 'left'">
        <span>项目</span>
      </div>
      <div @click="rightcandidates" :class="typeindex == 1 ? 'left_active' : 'left'">
        <span>人选</span>
      </div>
      <!-- <div @click="rightcollection" :class="typeindex == 2 ? 'left_active' : 'left'">
        <span>回款</span>
      </div> -->
    </div>
    <div v-if="typeindex == 0" class="container">
      <!-- 顶部条件筛选 -->
      <el-card class="labelStyle" :body-style="{ padding: '12px 16px' }">
        <el-form label-width="100px">
          <!-- <el-form-item label="项目进度：">
            <radio-select
              :code.sync="queryInfo.projectSchedule"
              type-code="011"
              @onChange="
                search()
                queryInfo.pageNum = 1
                queryInfo.pageSize = 30
              "
            />
          </el-form-item> -->
          <el-form-item label="项目状态：">
            <div class="buttonContent">
              <el-checkbox-button
                label="不限"
                :value="noLimit"
                @change="limitClick()"
              ></el-checkbox-button>
              <el-checkbox-group v-model="queryInfo.projectStatus" @change="noLimitClick()">
                <el-checkbox-button
                  v-for="(el, i) in codeData"
                  :key="i + 'only'"
                  :label="el.slice(0, 2)"
                >
                  {{ el }}
                </el-checkbox-button>
              </el-checkbox-group>
            </div>
          </el-form-item>
          <el-form-item label="优先级：">
            <radio-select
              :key="2"
              :code.sync="queryInfo.priority"
              type-code="009"
              @onChange="
                search()
                queryInfo.pageNum = 1
                queryInfo.pageSize = 30
              "
            />
          </el-form-item>
          <!-- <el-form-item label="项目类型：">
            <div class="project_type">
              <div
                class="type_item"
                v-for="(item, index) in pitchData"
                :key="index"
                :class="{ pitch: item.id == pitchId }"
                @click="clickPitch(item)"
              >
                {{ item.value }}
              </div>
            </div>
          </el-form-item> -->
          <el-form-item label="启动日期：">
            <radio-select
              :key="3"
              :code.sync="queryInfo.activateTime"
              type-code="019"
              @onChange="
                search()
                queryInfo.pageNum = 1
                queryInfo.pageSize = 30
              "
            />
          </el-form-item>
          <el-form-item label="推荐时间：">
            <radio-select
              :key="4"
              :code.sync="queryInfo.recommendedTime"
              type-code="019"
              @onChange="
                search()
                queryInfo.pageNum = 1
                queryInfo.pageSize = 30
              "
            />
          </el-form-item>
          <el-form-item label="更新时间：" style="margin-bottom: 0">
            <radio-select
              :key="5"
              :code.sync="queryInfo.queryTime"
              type-code="019"
              @onChange="
                search()
                queryInfo.pageNum = 1
                queryInfo.pageSize = 30
              "
            />
          </el-form-item>
        </el-form>
      </el-card>
      <!-- 中间区域 -->
      <el-card style="margin: 12px 0" :body-style="{ padding: '12px 16px' }">
        <div class="enterporise_list_input_add">
          <div class="left">
            <!-- <dic-sort
              sortName="项目进度"
              @handleSort="handleSort"
              :sortField="sortField"
              :extraInfo="queryInfo"
              :isUpActive="projectSchedule.isUpActive"
              :isDownActive="projectSchedule.isDownActive"
            /> -->
            <!-- <dic-sort
              sortName="优先级"
              @handleSort="handleSort"
              :sortField="sortField"
              :extraInfo="queryInfo"
              :isUpActive="priority.isUpActive"
              :isDownActive="priority.isDownActive"
            /> -->
            <!-- <dic-sort
              sortName="更新时间"
              @handleSort="handleSort"
              :sortField="sortField"
              :extraInfo="queryInfo"
              :isUpActive="updateTime.isUpActive"
              :isDownActive="updateTime.isDownActive"
            /> -->
            <div class="project_manager_search" v-if="roleIdShow">
              <div class="project_manager">
                <span>项目经理</span>
              </div>
              <el-select
                v-model="projectManagerValue"
                @change="changeProjectManager"
                filterable
                placeholder="请选择"
                @clear="clearItem"
              >
                <el-option
                  v-for="item in projectManagerList"
                  :key="item + 'only5'"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="right">
            <div class="input_new">
              <el-input
                placeholder="请输入企业名称"
                v-model="queryInfo.companyCorporateName"
                class="input-with-select"
                clearable
                @change="cleanSearch"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="
                    search()
                    queryInfo.pageNum = 1
                    queryInfo.pageSize = 30
                  "
                />
              </el-input>
            </div>
            <div class="input_new">
              <el-input
                placeholder="请输入职位名称"
                v-model="queryInfo.recruitmentCorporateName"
                class="input-with-select"
                clearable
                @change="cleanSearch"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="
                    search()
                    queryInfo.pageNum = 1
                    queryInfo.pageSize = 30
                  "
                />
              </el-input>
            </div>
            <el-button
              type="primary"
              class="add_enterprise"
              @click="addProjectDialog"
              v-has-permission="'/projectCenter/saveProject'"
              >+添加项目</el-button
            >
          </div>
        </div>
      </el-card>
      <!-- 内容区域-项目列表 -->
      <div class="page_nation">
        <!-- <div class="contentStyle" v-for="(item, index) in projectTable" :key="index">
          <div class="content_left">
            <div class="schedule" :class="getProjectScheduleColor(item.projectSchedule)">
              {{ item.projectSchedule }}
            </div>
            <div class="primary">

              <div class="enterprise">
                <div class="enterprise_title" @click="clickToDetails(item)">
                  {{ item.recruitmentPosition }}
                </div>
                <div class="imageBox">
                  <img v-if="item.companyLogo" :src="item.companyLogo" alt="" />
                  <img v-else :src="require('@/assets/pro.png')" alt="" />
                  <div class="img_txt">{{ item.corporateName }}</div>
                </div>
                <div class="tag" v-if="item.projectType == 1">外</div>

              </div>
              <div class="time">
                <span>最近推荐时间：</span>
                <span style="color: #333">{{ item.recommendDate }}</span>
              </div>
              <div class="recommend_interview_Number">
                <div class="recommend">
                  <div class="text">推荐人数</div>
                  <span class="line"></span>
                  <div class="number">{{ item.recommendNumber }}</div>
                </div>
                <div class="recommend">
                  <div class="text">面试人数</div>
                  <span class="line"></span>
                  <div class="number">{{ item.interviewNumber }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="content_right">
            <div class="manager">
              <div class="project_manager">
                <div class="label">
                  <span>项目经理：</span>
                </div>
                <diV class="value">
                  <span v-for="(i1, i2) in item.projectManagers" :key="i2">
                    {{ i1 }}
                  </span>
                </diV>
              </div>
              <div class="customer_manager">
                <div class="label">
                  <span>客户经理：</span>
                </div>
                <span>{{ item.customerManager }}</span>
              </div>
            </div>
            <div class="level">
              <span style="display: inline-block; min-width: 64px">优先级：</span>
              <dic-select
                class="mini-select"
                :code.sync="item.priority"
                type-code="009"
                :extraInfo="{ id: item.id, priority: item.priority }"
                placeholder="请选择"
                @changeVal="changePriority"
              />
            </div>
            <div class="operation">
              <div class="new_time">
                <span>最近更新时间：</span>
                <span>{{ item.updateTime }}</span>
              </div>
              <div class="operating_button">
                <div
                  class="btn_box workbench mr-r-10"
                  :class="getBtnColorBySchedule(item)"
                  @click="clickGoWorkbench(item)"
                >
                  工作台
                </div>
                <div
                  class="btn_box red mr-r-10"
                  :class="getBtnColorBySchedule(item)"
                  @click="deleteProject(item)"
                >
                  删除
                </div>
                <div
                  class="btn_box"
                  :class="getBtnColorBySchedule(item, 'isShelf')"
                  @click="setProjectShelf(item)"
                >
                  {{ item.isShelf ? '下架' : '上架' }}
                </div>
              </div>
            </div>
          </div>
        </div> -->

        <div>
          <!--
            height="calc(100vh - 526px)" -->
          <el-table
            ref="multipleTable"
            :data="projectTable"
            :header-cell-style="{ background: '#fff', color: '#1A1F33' }"
            tooltip-effect="dark"
            style="width: 100%"
            @sort-change="changeTableSort"
          >
            <el-table-column label="岗位" width="95px" align="center">
              <template slot-scope="scope">
                <span @click="clickToDetails(scope.row)" style="color: #17757a; cursor: pointer">
                  {{ scope.row.recruitmentPosition }}</span
                >
              </template>
            </el-table-column>
            <el-table-column label="企业" prop="10" sortable="custom" width="130px" align="center">
              <template slot-scope="scope">
                <span style="color: #17757a; cursor: pointer" @click="clickToDetails(scope.row)">
                  {{ scope.row.corporateName }}</span
                >
              </template>
            </el-table-column>

            <el-table-column label="城市" align="center">
              <template slot-scope="scope">{{ scope.row.city }}</template>
            </el-table-column>
            <el-table-column label="状态" prop="11" sortable="custom" width="100px" align="center">
              <template slot-scope="scope">
                <div v-if="positionType.indexOf('1') == -1">
                  <span class="green_back" v-if="scope.row.projectStatus == '活跃'">{{
                    scope.row.projectStatus
                  }}</span>
                  <span class="green_back redbg" v-if="scope.row.projectStatus == '紧急'">{{
                    scope.row.projectStatus
                  }}</span>
                  <span class="green_back yellowbg" v-if="scope.row.projectStatus == '暂缓'">{{
                    scope.row.projectStatus
                  }}</span>
                  <span class="green_back bluebg" v-if="scope.row.projectStatus == '暂停'">{{
                    scope.row.projectStatus
                  }}</span>
                  <span class="green_back huibg" v-if="scope.row.projectStatus == '关闭'">{{
                    scope.row.projectStatus
                  }}</span>
                  <span class="green_back success" v-if="scope.row.projectStatus == '成功'">{{
                    scope.row.projectStatus
                  }}</span>
                </div>
                <div v-else>
                  <dic-select
                    class="mini-select"
                    :code.sync="scope.row.projectStatus"
                    type-code="021"
                    :extraInfo="{ id: scope.row.id, projectStatus: scope.row.projectStatus }"
                    placeholder="请选择"
                    @changeVal="changeProjectStatus"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column label="优先级" prop="9" sortable="custom" width="100px" align="center">
              <template slot-scope="scope">
                <div v-if="positionType.indexOf('2') == -1">
                  <span>{{ scope.row.priority }}</span>
                </div>
                <div v-else>
                  <dic-select
                    class="mini-select"
                    :code.sync="scope.row.priority"
                    type-code="009"
                    :extraInfo="{ id: scope.row.id, priority: scope.row.priority }"
                    placeholder="请选择"
                    @changeVal="changePriority"
                  />
                </div>
              </template>
            </el-table-column>

            <el-table-column label="项目经理" align="center" width="180px">
              <template slot-scope="scope">
                <div>{{ scope.row.projectManager }}</div>
              </template>
            </el-table-column>
            <el-table-column label="客户经理" align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="modifyCustomerManager(scope.row)">{{
                  scope.row.customerManager
                }}</el-button>
              </template>
            </el-table-column>
            <el-table-column label="人选" prop="1" sortable="custom" align="center">
              <template slot-scope="scope">
                <div @click="toworkbench(scope.row)">
                  <span
                    style="color: #ff371c; cursor: pointer"
                    v-if="!scope.row.personChosenNumber"
                    >{{ scope.row.personChosenNumber }}</span
                  >
                  <span style="color: #17757a; cursor: pointer" v-else>
                    {{ scope.row.personChosenNumber }}</span
                  >
                </div>
              </template>
            </el-table-column>

            <el-table-column label="推荐" prop="2" sortable="custom" align="center">
              <template slot-scope="scope">
                <div @click="toworkbench(scope.row)">
                  <span style="color: #ff371c; cursor: pointer" v-if="!scope.row.recommendNumber">{{
                    scope.row.recommendNumber
                  }}</span>
                  <span style="color: #17757a; cursor: pointer" v-else>
                    {{ scope.row.recommendNumber }}</span
                  >
                </div>
              </template>
            </el-table-column>
            <el-table-column label="面试" prop="3" sortable="custom" align="center">
              <template slot-scope="scope">
                <div @click="toworkbench(scope.row)">
                  <span style="color: #ff371c; cursor: pointer" v-if="!scope.row.interviewNumber">{{
                    scope.row.interviewNumber
                  }}</span>
                  <span style="color: #17757a; cursor: pointer" v-else>
                    {{ scope.row.interviewNumber }}</span
                  >
                </div>
              </template>
            </el-table-column>
            <el-table-column label="offer" prop="4" sortable="custom" align="center">
              <template slot-scope="scope">
                <div @click="toworkbench(scope.row)">
                  <span style="color: #ff371c; cursor: pointer" v-if="!scope.row.offerNumber">{{
                    scope.row.offerNumber
                  }}</span>
                  <span style="color: #17757a; cursor: pointer" v-else>
                    {{ scope.row.offerNumber }}</span
                  >
                </div>
              </template>
            </el-table-column>
            <el-table-column label="淘汰" prop="5" sortable="custom" align="center">
              <template slot-scope="scope">
                <div @click="toworkbench(scope.row)">
                  <span style="color: #17757a; cursor: pointer" v-if="!scope.row.dieOutNumber">{{
                    scope.row.dieOutNumber
                  }}</span>
                  <span style="color: #17757a; cursor: pointer" v-else>
                    {{ scope.row.dieOutNumber }}</span
                  >
                </div>
              </template>
            </el-table-column>

            <el-table-column
              label="启动日期"
              align="center"
              sortable="custom"
              prop="8"
              min-width="100px"
            >
              <template slot-scope="scope">
                <div>{{ scope.row.createTime }}</div>
              </template>
            </el-table-column>
            <el-table-column
              label="最近推荐日期"
              align="center"
              sortable="custom"
              prop="6"
              min-width="130px"
            >
              <template slot-scope="scope">
                <div>{{ scope.row.recommendDate }}</div>
              </template>
            </el-table-column>
            <el-table-column
              label="最近更新日期"
              align="center"
              sortable="custom"
              prop="7"
              min-width="130px"
            >
              <template slot-scope="scope">
                <div>{{ scope.row.updateDayNumber }}</div>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" min-width="160px">
              <template slot-scope="scope">
                <div class="row">
                  <!-- <div
                    v-if="workbenchHasPermission"
                    class="row_css"
                    :class="getBtnColorBySchedule(scope.row)"
                    @click="clickGoWorkbench(scope.row)"
                  >
                    工作台
                  </div> -->
                  <div
                    v-if="workbenchHasPermission"
                    class="row_css"
                    :class="getBtnColorBySchedule(scope.row)"
                    @click="clickGoWorkbench(scope.row, 1)"
                  >
                    推荐列表
                  </div>
                  <div
                    v-if="workbenchHasPermission"
                    class="row_css"
                    :class="getBtnColorBySchedule(scope.row)"
                    @click="clickGoWorkbench(scope.row, 2)"
                  >
                    文档中心
                  </div>
                  <div class="row_red" v-if="positionType.indexOf('1') != '-1'">
                    <i
                      v-if="deleteHasPermission"
                      @click="deleteProject(scope.row)"
                      class="el-icon-delete"
                    ></i>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div v-if="typeindex == 1" class="container">
      <!-- 顶部条件筛选 -->
      <el-card class="labelStyle" :body-style="{ padding: '12px 16px' }">
        <el-form label-width="100px">
          <el-form-item label="人选状态：">
            <!-- <radio-select
              :key="6"
              :code.sync="query.candidateStatus"
              type-code="022"
              @onChange="selectPersonChosen()"
            /> -->
            <div class="openClose">
              <div class="openInfo">
                <el-radio-group v-model="query.candidateStatus" @change="changeCandidateStatus">
                  <el-radio-button label>不限</el-radio-button>
                  <el-radio-button
                    v-for="(item, index) in candidatesData"
                    :key="index + 'only'"
                    :label="String(index + 1)"
                  >
                    {{ item }}
                  </el-radio-button>
                </el-radio-group>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="推荐时间：">
            <radio-select
              :key="7"
              :code.sync="query.recommendedTime"
              type-code="019"
              @onChange="selectPersonChosen()"
            />
          </el-form-item>
          <el-form-item label="更新时间：" style="margin-bottom: 0">
            <radio-select
              :key="8"
              :code.sync="query.updateTime"
              type-code="019"
              @onChange="selectPersonChosen()"
            />
          </el-form-item>
        </el-form>
      </el-card>
      <!-- 中间区域 -->
      <el-card style="margin: 12px 0" :body-style="{ padding: '12px 16px' }">
        <div class="enterporise_list_input_add">
          <div class="left">
            <div class="project_manager_search" v-if="roleIdShow">
              <div class="project_manager">
                <span>项目经理</span>
              </div>
              <el-select
                v-model="projectManagerValue"
                @change="changeProjectManager"
                filterable
                placeholder="请选择"
                @clear="clearItem"
              >
                <el-option
                  v-for="item in projectManagerList"
                  :key="item + 'only1'"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="right">
            <div class="input_new">
              <el-input
                placeholder="请输入企业名称"
                v-model="query.companyCorporateName"
                class="input-with-select"
                clearable
                @change="cleanQuerySearch"
              >
                <el-button slot="append" icon="el-icon-search" @click="selectPersonChosen()" />
              </el-input>
            </div>
            <div class="input_new">
              <el-input
                placeholder="请输入职位名称"
                v-model="query.recruitmentCorporateName"
                class="input-with-select"
                clearable
                @change="cleanQuerySearch"
              >
                <el-button slot="append" icon="el-icon-search" @click="selectPersonChosen()" />
              </el-input>
            </div>
          </div>
        </div>
      </el-card>
      <!-- 内容区域-项目列表 -->
      <div class="page_nation">
        <div>
          <!--
            height="calc(100vh - 436px)" -->
          <el-table
            ref="multipleTable"
            :data="personTable"
            :header-cell-style="{ background: '#fff', color: '#1A1F33' }"
            tooltip-effect="dark"
            style="width: 100%"
            @sort-change="changeTableSorts"
          >
            <el-table-column label="人选" width="120px" align="center">
              <template slot-scope="scope">
                <span style="color: #17757a"> {{ scope.row.name }}</span>
              </template>
            </el-table-column>
            <el-table-column label="企业" prop="10" sortable="custom" width="130px" align="center">
              <template slot-scope="scope">
                <span style="color: #17757a"> {{ scope.row.corporateName }}</span>
              </template>
            </el-table-column>

            <el-table-column label="岗位" align="center">
              <template slot-scope="scope">
                <span style="color: #17757a">{{ scope.row.recruitmentPosition }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="状态"
              prop="11"
              sortable="custom"
              min-width="90px"
              align="center"
            >
              <template slot-scope="scope">
                <!-- <span  v-if="scope.row.candidateStatus=='1'">待回复</span>
              <span  v-if="scope.row.candidateStatus=='2'">初试</span>
              <span  v-if="scope.row.candidateStatus=='3'">复试</span>
              <span v-if="scope.row.candidateStatus=='4'">offer</span>
              <span  v-if="scope.row.candidateStatus=='5'">待入职</span>
              <span  v-if="scope.row.candidateStatus=='6'">保证期</span>
              <span v-if="scope.row.candidateStatus=='7'">淘汰</span> -->
                <span class="block_flex"></span>
                <span>{{ scope.row.candidateStatus }}</span>
              </template>
            </el-table-column>

            <el-table-column
              label="推荐日期"
              align="center"
              sortable="custom"
              prop="1"
              min-width="120px"
            >
              <template slot-scope="scope">
                <div>{{ scope.row.recommendDate }}</div>
              </template>
            </el-table-column>
            <el-table-column
              label="最近联系时间"
              align="center"
              sortable="custom"
              prop="2"
              min-width="140px"
            >
              <template slot-scope="scope">
                <div>{{ scope.row.updateDayNumber }}</div>
              </template>
            </el-table-column>
            <el-table-column label="备注" align="center" min-width="340px">
              <template slot-scope="scope">
                <!-- <span>{{ scope.row.candidateRemarks }}</span> -->
                <el-tooltip placement="bottom" effect="light">
                  <div class="candidateRemarks" slot="content">
                    {{ scope.row.candidateRemarks }}
                  </div>
                  <el-button
                    v-if="scope.row.candidateRemarks"
                    type="text"
                    class="candidateRemarks_txt"
                    >{{ scope.row.candidateRemarks }}</el-button
                  >
                </el-tooltip>
                <div v-if="positionType.indexOf('2') != -1" @click="addcandidate(scope.row)">
                  <span v-if="!scope.row.candidateRemarks" style="color: #17757a; cursor: pointer"
                    >添加</span
                  >
                  <span v-if="scope.row.candidateRemarks" style="color: #17757a; cursor: pointer"
                    >修改</span
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div v-if="typeindex == 2" class="container">
      <!-- 顶部条件筛选 -->
      <el-card class="labelStyle" :body-style="{ padding: '12px 16px' }">
        <el-form label-width="100px">
          <el-form-item label="收款状态：">
            <radio-select
              :key="6"
              :code.sync="query.candidateStatus"
              type-code="022"
              @onChange="selectPersonChosen()"
            /> </el-form-item
          >=
          <el-form-item label="开发票：" style="margin-bottom: 0">
            <radio-select
              :key="7"
              :code.sync="query.recommendedTime"
              type-code="019"
              @onChange="selectPersonChosen()"
            />
          </el-form-item>
        </el-form>
      </el-card>
      <!-- 中间区域 -->
      <el-card style="margin: 12px 0">
        <div class="enterporise_list_input_add">
          <div class="left"></div>
          <div class="right">
            <div class="input_new">
              <el-input
                placeholder="请输入企业、职位名称"
                v-model="query.corporateName"
                class="input-with-select"
                clearable
              >
                <el-button slot="append" icon="el-icon-search" @click="selectPersonChosen()" />
              </el-input>
            </div>
          </div>
        </div>
      </el-card>
      <!-- 内容区域-项目列表 -->
      <!--
            height="calc(100vh - 500px)" -->
      <div class="page_nation">
        <div>
          <el-table
            ref="multipleTable"
            :data="personTable"
            :header-cell-style="{ background: '#fff', color: '#1A1F33' }"
            tooltip-effect="dark"
            style="width: 100%"
            @sort-change="changeTableSorts"
          >
            <el-table-column label="企业" prop="10" sortable="custom" width="120px" align="center">
              <template slot-scope="scope">
                <span style="color: #17757a"> {{ scope.row.name }}</span>
              </template>
            </el-table-column>
            <el-table-column label="岗位" width="130px" align="center">
              <template slot-scope="scope">
                <span style="color: #17757a"> {{ scope.row.corporateName }}</span>
              </template>
            </el-table-column>

            <el-table-column label="人选" align="center">
              <template slot-scope="scope">
                <span style="color: #17757a">{{ scope.row.recruitmentPosition }}</span>
              </template>
            </el-table-column>
            <el-table-column label="收款金额" min-width="90px" align="center">
              <template slot-scope="scope">
                <span class="block_flex"></span>
                <span>{{ scope.row.candidateStatus }}</span>
              </template>
            </el-table-column>

            <el-table-column
              label="应收日期"
              align="center"
              sortable="custom"
              prop="1"
              min-width="120px"
            >
              <template slot-scope="scope">
                <div>{{ scope.row.recommendDate }}</div>
              </template>
            </el-table-column>
            <el-table-column
              label="开票日期"
              align="center"
              sortable="custom"
              prop="1"
              min-width="120px"
            >
              <template slot-scope="scope">
                <div>{{ scope.row.recommendDate }}</div>
              </template>
            </el-table-column>
            <el-table-column label="尾款金额" min-width="90px" align="center">
              <template slot-scope="scope">
                <span class="block_flex"></span>
                <span>{{ scope.row.candidateStatus }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="开票日期"
              align="center"
              sortable="custom"
              prop="1"
              min-width="120px"
            >
              <template slot-scope="scope">
                <div>{{ scope.row.recommendDate }}</div>
              </template>
            </el-table-column>
            <el-table-column label="客户经理" align="center" min-width="140px">
              <template slot-scope="scope">
                <div>{{ scope.row.updateDayNumber }}</div>
              </template>
            </el-table-column>
            <el-table-column label="备注" align="center" width="340px">
              <template slot-scope="scope">
                <!-- <span>{{ scope.row.candidateRemarks }}</span> -->
                <el-tooltip placement="bottom" effect="light">
                  <div class="candidateRemarks" slot="content">
                    {{ scope.row.candidateRemarks }}
                  </div>
                  <el-button
                    v-if="scope.row.candidateRemarks"
                    type="text"
                    class="candidateRemarks_txt"
                    >{{ scope.row.candidateRemarks }}</el-button
                  >
                </el-tooltip>
                <div v-if="positionType.indexOf('2') != -1" @click="addcandidate(scope.row)">
                  <span v-if="!scope.row.candidateRemarks" style="color: #17757a; cursor: pointer"
                    >添加</span
                  >
                  <span v-if="scope.row.candidateRemarks" style="color: #17757a; cursor: pointer"
                    >修改</span
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!-- 分页器 -->
    <div v-if="typeindex == 0" class="pagination">
      <el-pagination
        :current-page="queryInfo.pageNum"
        :page-sizes="[10, 30, 60]"
        :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <div v-if="typeindex == 1" class="pagination">
      <el-pagination
        :current-page="query.pageNum"
        :page-sizes="[10, 30, 60]"
        :page-size="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="persontotal"
        @size-change="handleSizeChanges"
        @current-change="handleCurrentChanges"
      />
    </div>
    <!-- 可能是已删除的功能 -->
    <!-- <el-dialog
      ref="addVisible"
      :visible.sync="dialogVisible"
      width="40%"
      @close="handleClose"
      center
    >
      <title-bar slot="title" title="添加目标企业" />
      <div class="search-input" :class="{ 'search-enterprise': isShowEnterprise }">
        <el-input placeholder="请输入关键词" v-model="enterprise" clearable>
          <el-button slot="append" icon="el-icon-search" @click="searchEnterprise" />
        </el-input>
      </div>
      <div v-if="isShowEnterprise" class="enterpriseInfo">
        <div class="left">
          <el-image
            class="companyLogo"
            :src="enterpriseObj.companyKey"
            style="width: 80px; height: 80px"
            fit="fit"
          />
          <div class="info">
            <div class="companyFullName">{{ enterpriseObj.companyFullName }}</div>
            <div class="industry">
              {{ enterpriseObj.industry }}
              <div class="area">
                <span class="line">|</span>
                {{ enterpriseObj.companyCountry }}{{ enterpriseObj.companyProvince
                }}{{ enterpriseObj.companyCity }}
              </div>
            </div>
          </div>
        </div>
        <icon-and-button
          title="添加"
          icon="icon-jr-icon-yes"
          :buttonStyle="{ color: '#17757A' }"
          @handleControl="handleControl"
        />
      </div>

      <div class="hasAddEnterprise">
        <p>已添加的企业</p>
        <div
          v-for="(item, index) in targetEnterpriseList"
          :key="index"
          class="targetEnterprise enterpriseInfo"
        >
          <div class="left">
            <el-image
              class="companyLogo"
              :src="item.companyLogoKey"
              style="width: 80px; height: 80px"
              fit="fit"
            />
            <div class="info">
              <div class="companyFullName">{{ item.companyFullName }}</div>
              <div class="industry">
                {{ item.industry }}
                <div class="area">
                  <span class="line">|</span>
                  {{ item.companyCountry }}{{ item.companyProvince }}{{ item.companyCity }}
                </div>
              </div>
            </div>
          </div>
          <icon-and-button
            title="取消"
            icon="icon-jr-icon-delete"
            :iconStyle="{ color: '#FA5050' }"
            :extraInfo="{ enterpriseId: item.id }"
            @handleControl="handleControl"
          />
        </div>
      </div>
    </el-dialog> -->
    <!-- 添加项目弹窗 -->
    <el-dialog
      title="人选备注"
      :visible.sync="dialogVisibleadd"
      width="30%"
      :before-close="addhandleClose"
    >
      <div>
        <el-input
          type="textarea"
          :autosize="{ minRows: 8, maxRows: 6 }"
          placeholder="请输入内容"
          v-model="candidateinfo.candidateRemarks"
        >
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleadd = false">取 消</el-button>
        <el-button type="primary" @click="updateCandidateRemarks">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      @close="closeAddDialog"
      :visible.sync="addProjectDialogShow"
      width="50%"
      class="add_project_dialog"
    >
      <!-- 头部 -->
      <span slot="title" class="dialog-footer">
        <div class="title">
          <div class="line"></div>
          <div class="title_txt">添加项目</div>
        </div>
      </span>
      <!-- 中间内容 -->
      <div class="add_project_form">
        <el-form :model="form" :rules="rules" ref="form" label-width="100px" class="demo-ruleForm">
          <el-form-item label="项目类型" prop="projectType">
            <el-radio-group v-model="form.projectType">
              <el-radio label="0">自营项目</el-radio>
              <el-radio label="1">外部项目</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="企业名称">
            <el-autocomplete
              class="inline-input"
              v-model="form.enterpriseName"
              :fetch-suggestions="enterpriseNameQuerySearch"
              placeholder="请输入"
              :trigger-on-focus="false"
              @select="enterpriseNameSelect"
              @input="inputChanged"
            ></el-autocomplete>
          </el-form-item>
          <el-form-item label="职位名称" prop="recruitmentPosition">
            <el-autocomplete
              class="inline-input"
              v-model="form.recruitmentPosition"
              :fetch-suggestions="positionListQuerySearch"
              placeholder="请选择"
              @select="positionSelect"
              @input="inputChanged"
            ></el-autocomplete>
          </el-form-item>
          <!-- <el-form-item label="岗位名称" prop="recruitmentPosition">
            <el-select v-model="positionId" placeholder="请选择" @change="selectionChanged">
              <el-option
                v-for="(i1, i2) in positionList"
                :key="i2"
                :label="i1.jobTitle"
                :value="i1.id"
              >
              </el-option>
              <div slot="empty" style="color: #c0c4cc; text-align: center; line-height: 40px">
                请先添加职位
              </div>
            </el-select>
          </el-form-item> -->
          <!-- 3月20日删除上传 -->
          <!-- <el-form-item label="上传JD">
            <el-upload
              class="upload-demo"
              action
              :http-request="uploadFile"
              ref="upload"
              :limit="1"
              :file-list="fileList"
              :show-file-list="false"
            >
              <div class="upload_button">上传JD</div>
            </el-upload>
          </el-form-item> -->
          <el-form-item label="项目经理" prop="projectManager" class="add_project_manager">
            <el-select v-model="form.projectManager" placeholder="请选择" multiple>
              <el-option
                v-for="(item, index) in dialogProjectManagerList"
                :key="index + 'only2'"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <!-- 3月20日删除上传 -->
        <!-- <el-tooltip
          class="item"
          effect="dark"
          :content="tag.name"
          placement="top-start"
          v-for="(tag, index) in fileList"
          :key="index"
        >
          <el-tag
            style="margin-right: 10px; display: flex; align-items: center"
            :disable-transitions="false"
            @close="handleCloseUpload(index)"
            closable
            ><span class="tagtext">{{ tag.name }}</span></el-tag
          >
        </el-tooltip> -->
      </div>
      <!-- 底部按钮 -->
      <div slot="footer" class="dialog-footer">
        <div class="button_box">
          <div class="add" @click="addProject">添加</div>
          <div class="cancel" @click="addProjectDialogShow = false">取消</div>
        </div>
      </div>
    </el-dialog>
    <!-- 修改客户经理 -->
    <el-dialog title="修改客户经理" :visible.sync="customerManagerDialogForm">
      <el-form :model="customerManagerForm">
        <el-form-item label="客户经理">
          <el-select v-model="customerManagerForm.manager" multiple placeholder="请选择">
            <el-option
              v-for="(item, index) in customerManagerList"
              :key="index + 'only3'"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="customerManagerDialogForm = false">取 消</el-button>
        <el-button type="primary" @click="modifyApiCustomerManager">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import radioSelect from '@/components/RadioSelect.vue'
import {
  projectCenterDeleteById,
  getProjectCenter,
  deleteProjectCenter,
  getEnterprise,
  getTargetEnterprise,
  addTargetEnterprise,
  deleteTargetEnterprise,
  updatePriority,
  updateFreezeState,
  updateStatus,
  selectProjectCenterTwo,
  getProjectManager,
  saveProject,
  updateProjectManager,
  projectShelf,
  updateCandidateRemarks,
  updategetCustomerManager,
  selectUpdateCustomerManager,
  selectProjectCenterNumber,
  selectPersonChosenNumber
} from '@/api/projectCenter.js'
import { pagination } from '@/mixins/pagination'
// import DicSort from '@/components/DicSort.vue'
import DicSelect from '@/components/DicSelect.vue'
//import IconAndButton from '@/components/IconAndButton.vue'
//import TitleBar from '@/components/TitleBar.vue'
import { getCompanyNameList, selectPersonChosen } from '@/api/projectCenter.js'
import { selectPosition } from '@/api/position.js'
import { codeType } from '@/api/common.js'
// import multiSelect from '@/components/MultiSelect.vue'

const positionType = sessionStorage.getItem('position')

const defaultQuery = Object.freeze({
  candidateStatus: '', //人选状态（1、待回复；2、初试；3、复试；4、offer；5、待入职；6、保证期；7、淘汰）
  columnName: '', //排序字段(1、推荐日期；2、最近联系时间；)
  // corporateName: '', //搜索框(企业、岗位、姓名)
  recruitmentCorporateName: '', //搜索公司名称
  companyCorporateName: '', //搜索公司企业名称
  order: '', //排序（1、升序;2、降序）
  projectManager: '', //项目经理
  recommendedTime: '', //推荐日期（一周；一月；一季度；一年）
  updateTime: '', //最近联系时间（一周；一月；一季度；一年）
  pageNum: 1, //页数
  pageSize: 10 //大小
})

const defaultQueryInfo = Object.freeze({
  projectSchedule: '', // 项目进度
  priority: '', // 优先级
  columnName:
    positionType.indexOf('1') != '-1' ? '13' : positionType.indexOf('2') != '-1' ? '12' : '7', //排序字段
  // corporateName: '', //搜索字段
  recruitmentCorporateName: '', //搜索公司名称
  companyCorporateName: '', //搜索公司企业名称
  order: '0', //排序
  pageNum: 1, //页数
  pageSize: 10, //大小
  size: '', //所选条数
  type: null,
  projectType: 3, // 项目类型0->内；1->外
  queryTime: '', //查询时间（一周；一月；一季度；一年）
  projectManager: '', // 项目经理
  activateTime: '', //启动时间（一周；一月；一季度；一年）
  projectStatus: ['紧急', '活跃'], //项目状态：code表021(紧急,活跃,暂缓,暂停,关闭,成功)
  recommendedTime: '' //推荐时间（一周；一月；一季度；一年）
})
const defaultForm = Object.freeze({
  positionType: '', // 职位类型
  dutyStation: '', // 工作地址-详细地址
  isAnnual: null, // 月薪或者年薪0->月薪；1->年薪
  salaryRange: '', // 薪资范围
  jobDescription: '', // 职位描述
  area: '', // 工作地区 地区
  province: '', // 工作省份
  city: '', // 工作城市
  requiredSkills: '', // 所需技能
  companyProfile: '', // 公司简介
  industry: '', // 所属行业
  projectType: '0', // 项目类型
  enterpriseName: '', // 企业名称
  projectManager: '',
  customerManager: sessionStorage.getItem('projectManager'),
  recruitmentPosition: '' //岗位名称
})
const defaultProjectSchedule = Object.freeze({
  name: '项目进度',
  isUpActive: false, //激活'up'样式
  isDownActive: false //激活'down'样式
})
const defaultPriority = Object.freeze({
  name: '优先级',
  isUpActive: false, //激活'up'样式
  isDownActive: false //激活'down'样式
})
const defaultUpdateTime = Object.freeze({
  name: '更新时间',
  isUpActive: false, //激活'up'样式
  isDownActive: false //激活'down'样式
})

export default {
  //IconAndButton,TitleBar
  components: {
    radioSelect,
    // DicSort,
    DicSelect
    // multiSelect
  },
  mixins: [pagination],
  data() {
    return {
      typeCode: '021', //查询字符串
      noLimit: [],
      codeData: [], //项目数据循环
      stateList: [], //项目状态数组
      candidatesCode: '022', // 人选状态字符串
      candidatesData: [], // 人选状态数组循环
      candidatesList: [], //人选状态数组
      personTable: [],
      persontotal: 0,
      query: { ...defaultQuery },
      loading: false,
      roleId: '',
      projectSchedule: { ...defaultProjectSchedule },
      updateTime: { ...defaultPriority },
      priority: { ...defaultUpdateTime },
      order: '', // 顺序
      sortField: '', // 排序名
      roleIdShow: true, //项目经理的显示
      queryInfo: { ...defaultQueryInfo },
      projectTable: [], // 表格数据
      dialogVisible: false, // 弹窗状态
      id: '', // 项目id
      enterprise: '', // 企业查询
      enterpriseObj: {}, // 查询到的企业
      targetEnterpriseList: [], // 目标企业
      isShowEnterprise: false,
      pitchId: '',
      projectManagerList: [], // 查询到的项目经理
      dialogProjectManagerList: [], // 查询到的项目经理
      projectManagerValue: '', //选中的项目经理
      projectManagerValueTwo: '',
      typeindex: 0,
      pitchData: [
        {
          id: '',
          value: '不限'
        },
        {
          id: '0',
          value: '内'
        },
        {
          id: '1',
          value: '外'
        }
      ],
      addProjectDialogShow: false, // 添加项目弹窗
      form: { ...defaultForm }, // 表单数据
      rules: {
        projectType: [{ required: true, message: '请选择项目类型', trigger: 'blur' }],
        enterpriseName: [{ required: true, message: '请输入企业名称', trigger: 'blur' }],
        projectManager: [{ required: true, message: '请选择项目经理', trigger: 'blur' }],
        file: [{ required: true, message: '请上传JD' }]
      },
      fileList: [], //3月20日删除上传
      enterpriseNameList: [], //查询到的企业名称
      positionId: null, //  选中的职位id
      positionLists: [], // 查询到的职位相关数据
      positionList: [], //查询到的职位名称
      positionType: sessionStorage.getItem('position'),
      dialogVisibleadd: false,
      candidateinfo: {}, //人选备注详情
      currentErpriseName: '', //当前选中的公司名称
      customerManagerForm: {
        manager: [],
        projectId: ''
      },
      customerManagerDialogForm: false, // 打开修改客户经理弹窗
      customerManagerList: [] // 客户经理数据列表
    }
  },
  computed: {
    getProjectScheduleColor() {
      return function (val) {
        let str = ''
        switch (val) {
          case '前期筹备':
            str = 'color1'
            break
          case '人才mapping':
            str = 'color2'
            break
          case '面试邀约':
            str = 'color3'
            break
          case 'offer谈判':
            str = 'color4'
            break
          case '后续跟进':
            str = 'color5'
            break
          case '已完成':
            str = 'color6'
            break
          case '已结束':
            str = 'color7'
            break
          case '冻结':
            str = 'color8'
            break
          case '保证期结束':
            str = 'color9'
            break
          case '立项':
            str = 'color10'
            break
          case '人才推荐':
            str = 'color11'
            break
          case 'offer接受':
            str = 'color12'
            break
          case '入职':
            str = 'color13'
            break
          default:
            break
        }
        return str
      }
    },
    workbenchHasPermission() {
      const userPermissions = JSON.parse(sessionStorage.getItem('menuTree')).flatMap(
        (outerItem) => {
          return outerItem.children.flatMap((item) => item.children.map((i) => i.path))
        }
      )
      const hasPermission = userPermissions.includes('/projectCenter/selectBYId')
      return hasPermission
    },
    // /projectCenter/deleteById
    deleteHasPermission() {
      const userPermissions = JSON.parse(sessionStorage.getItem('menuTree')).flatMap(
        (outerItem) => {
          return outerItem.children.flatMap((item) => item.children.map((i) => i.path))
        }
      )
      const hasPermission = userPermissions.includes('/projectCenter/deleteById')
      return hasPermission
    }
  },
  created() {
    // if (Object.keys(this.$store.state.queryInfo).length) {
    //   Object.keys(this.$store.state.queryInfo).forEach((item) => {
    //     this.queryInfo[item] = this.$store.state.queryInfo[item]
    //   })
    // }

    this.roleId = sessionStorage.getItem('roleId')
    let nameEnglish = sessionStorage.getItem('nameEnglish')
    // this.projectManagerValue=nameEnglish
    // this.queryInfo.projectManager = nameEnglish
    // console.log("判断是否是管理员",this.roleId)
    // 如果角色不是超级管理员
    let projectManager = sessionStorage.getItem('projectManager')
    if (!projectManager) {
      //第一次登录缓存中没有projectManager
      if (this.roleId != 1) {
        this.queryInfo.projectManager = nameEnglish
        this.projectManagerValue = nameEnglish
      }
    } else if (projectManager == 'xxx' && projectManager == '') {
      //清空项目经理选项框以后
      this.queryInfo.projectManager = ''
      this.projectManagerValue = ''
    } else if (projectManager != 'xxx' && projectManager != '') {
      //选中项目经理后
      this.queryInfo.projectManager = projectManager
      this.projectManagerValue = projectManager
    }
    this.getProjectManagerList()
    this.getCode(this.typeCode)
  },
  methods: {
    changeSelectProjectStatus(data) {
      this.queryInfo.projectStatus = data
      this.queryInfo.pageNum = 1
      this.queryInfo.pageSize = 30
      this.search()
    },
    async updateCandidateRemarks() {
      const query = {
        candidateRemarks: this.candidateinfo.candidateRemarks,
        id: this.candidateinfo.id
      }
      const { data: res } = await updateCandidateRemarks(query)
      if (res.resultCode === 200) {
        this.dialogVisibleadd = false
        this.$message.success('修改成功!')
        this.selectPersonChosen()
      }
    },
    //添加人选备注
    addcandidate(item) {
      this.candidateinfo = { ...item }
      this.dialogVisibleadd = true
    },
    addhandleClose() {
      this.dialogVisibleadd = false
    },
    leftproject() {
      this.typeindex = 0
      this.search()
    },
    rightcandidates() {
      this.typeindex = 1
      this.selectPersonChosen()
      this.getCode(this.candidatesCode)
    },
    rightcollection() {
      this.typeindex = 2
    },
    changeTableSorts(column) {
      if (column.order == 'ascending') {
        this.query.order = '1'
        this.query.columnName = column.prop
      } else if (column.order == 'descending') {
        this.query.order = '0'
        this.query.columnName = column.prop
      } else {
        this.query.order = '0'
        this.query.columnName = '1'
      }

      this.selectPersonChosen()
    },
    // 表格排序
    changeTableSort(column) {
      if (column.order == 'ascending') {
        this.queryInfo.order = '1'
        this.queryInfo.columnName = column.prop
      } else if (column.order == 'descending') {
        this.queryInfo.order = '0'
        this.queryInfo.columnName = column.prop
      } else {
        this.queryInfo.order = '0'
        this.queryInfo.columnName = '7'
      }
      if (this.queryInfo.columnName == 9) {
        this.queryInfo.type = '009'
      }

      this.search()
    },
    // 获取按钮class
    getBtnColorBySchedule(item, val) {
      if (item.projectSchedule === '冻结') {
        // 冻结状态统一样式
        return 'freeze'
      } else if (val === 'isShelf') {
        // 上下架按钮
        if (item.isShelf) {
          return 'workbench'
        } else {
          return 'normal'
        }
      }
    },
    handleSizeChange(val) {
      this.queryInfo.pageSize = val
      this.search()
    },
    handleCurrentChange(val) {
      this.queryInfo.pageNum = val
      this.search()
    },
    handleSizeChanges(val) {
      this.query.pageSize = val
      this.selectPersonChosen()
    },
    handleCurrentChanges(val) {
      this.query.pageNum = val
      this.selectPersonChosen()
    },
    //清除项目经理选择
    clearItem() {
      sessionStorage.setItem('projectManager', 'xxx')
      this.search()
    },
    clickPitch(item) {
      // console.log(item)
      this.pitchId = item.id
      this.queryInfo.projectType = item.id
      this.search()
    },

    // 查询目标企业
    async searchTargetEnterprise() {
      const { data: res } = await getTargetEnterprise({ id: this.id })
      if (res.resultCode === 200) {
        this.targetEnterpriseList = res.data
        this.dialogVisible = true
      }
    },
    // 获取项目经理
    async getProjectManagerList() {
      const { data: res } = await getProjectManager()
      if (res.resultCode == 200) {
        this.projectManagerList = res.data
        this.dialogProjectManagerList = [...res.data]
        this.projectManagerList.unshift('全部')
        let nameEnglish = sessionStorage.getItem('nameEnglish')
        this.projectManagerValue = nameEnglish
        this.queryInfo.projectManager = nameEnglish
        this.query.projectManager = nameEnglish
        // 条件成立则是项目经理
        if (this.positionType.indexOf('2') != -1) {
          this.queryInfo.projectManager = nameEnglish
          this.queryInfo.customerManager = ''
          this.projectManagerValue = nameEnglish
        }
        // 条件成立则是客户经理
        else if (this.positionType.indexOf('1') != -1) {
          this.queryInfo.projectManager = ''
          this.queryInfo.customerManager = nameEnglish
          this.projectManagerValue = '全部'
        }
        this.search()
      }
    },
    // 新增项目经理选中后的值
    /* async changeAddProject(itemVal, id) {
      let query = {
        manager: itemVal,
        projectId: id
      }
      const { data: res } = await updateProjectManager(query)
      if (res.resultCode == 200) {
        this.$message.success('操作成功')
      }
    }, */
    // 项目经理选择好后的值--查询
    changeProjectManager() {
      sessionStorage.setItem('projectManager', this.projectManagerValue)
      this.queryInfo.projectManager = this.projectManagerValue
      this.query.projectManager = this.projectManagerValue
      if (this.projectManagerValue == '全部') {
        this.queryInfo.projectManager = ''
        this.query.projectManager = ''
      }
      this.selectPersonChosen()
      this.search()
    },
    toworkbench(item) {
      this.$router.push({
        path: '/businessManagement/workbench',
        query: {
          item: JSON.stringify(item),
          height: 2
        }
      })
    },
    // 跳转到工作台页面
    clickGoWorkbench(item, type) {
      // if (item.projectSchedule == '冻结') {
      //   return this.$message('此项目已冻结,请解冻后重试')
      // }
      this.$router.push({
        path: '/businessManagement/workbench',
        query: {
          item: JSON.stringify(item),
          type: type
        }
      })
    },
    // 删除项目
    async deleteProject(item) {
      // if (item.projectSchedule == '冻结') {
      //   return this.$message('此项目已冻结,请解冻后重试')
      // }
      this.$confirm('确认删除吗 ?', '提示')
        .then(async () => {
          const { data: res } = await projectCenterDeleteById({ id: item.id })
          if (res.resultCode === 200) {
            this.search()
            this.$message.success(res.message)
          }
        })
        .catch(() => {})
    },
    // 上下架项目
    async setProjectShelf(item) {
      // if (item.projectSchedule == '冻结') {
      //   return this.$message('此项目已冻结,请解冻后重试')
      // }
      const { id, isShelf } = item
      const txt = isShelf ? '下架' : '上架'
      const query = { id, isShelf: !isShelf }
      const { data: res } = await projectShelf(query)
      if (res.resultCode === 200) {
        this.$message.success(txt + '成功!')
        this.search()
      } else {
        this.$message.error(txt + '失败!')
      }
    },
    // 查询企业
    async searchEnterprise() {
      const { data: res } = await getEnterprise({ companyFullName: this.enterprise })
      if (res.resultCode === 200) {
        if (res.data) {
          this.enterpriseObj = res.data
          this.isShowEnterprise = true
        } else {
          this.enterpriseObj = {}
          this.isShowEnterprise = false
        }
      }
    },
    // searchLabel(data) {
    //   this.queryInfo.cilentIndustry = data
    //   this.search()
    // },
    //查询一览
    async search() {
      this.loading = true
      // console.log(this.queryInfo, JSON.stringify(this.queryInfo), "this.queryInfothis.queryInfothis.queryInfo");
      const { data: res } = await selectProjectCenterTwo(this.queryInfo)
      if (res.resultCode === 200) {
        this.projectTable = res.data.list
        this.total = res.data.total
        this.loading = false
      } else {
        this.loading = false
        this.$message.error('获取项目信息失败!')
      }
      // const newProjectTable = this.projectTable.map(item => {
      //   // console.log("遍历数据",item.projectStatus);
      //   return item.projectStatus
      // })
      // console.log("遍历数据", newProjectTable);
    },
    //根据code查询标签
    async getCode(code) {
      const res = await codeType({ code: code })
      if (res.data.resultCode == 200) {
        const newCodeData = res.data.data.map((item) => {
          return item.codeName
        })
        if (code == '021') {
          const { data: req } = await selectProjectCenterNumber(newCodeData)
          const newNumber = req.data.split(',')
          const handleCodeData = newCodeData.map((item, index) => {
            return item + `(${newNumber[index]})`
          })
          this.codeData = handleCodeData
        }
        if (code == '022') {
          const { data: req } = await selectPersonChosenNumber(newCodeData)
          const newNumber = req.data.split(',')
          const handleCodeData = newCodeData.map((item, index) => {
            return item + `(${newNumber[index]})`
          })
          this.candidatesData = handleCodeData
        }
      }
    },
    // 项目选择发生变化的时候
    limitClick() {
      if (this.queryInfo.projectStatus.length > 0) {
        ;(this.queryInfo.projectStatus = []), (this.noLimit = ['不限'])
        this.search()
      } else {
        this.noLimit = ['不限']
        this.search()
      }
    },
    // 人选选择发生变化的时候
    changeCandidateStatus(val) {
      this.query.candidateStatus = val
      this.selectPersonChosen()
    },
    // 多选发生变化时
    noLimitClick() {
      if (this.queryInfo.projectStatus.length > 0) {
        this.noLimit = []
        this.search()
      } else {
        this.noLimit = ['不限']
        this.search()
      }
    },

    async selectPersonChosen() {
      this.loading = true
      const { data: res } = await selectPersonChosen({ ...this.query })
      if (res.resultCode === 200) {
        this.personTable = res.data.list
        this.persontotal = res.data.total
        this.loading = false
      } else {
        this.loading = false
        this.$message.error('获取人选信息失败!')
      }
    },

    //通过省市筛选
    searchArae(val) {
      this.queryInfo.workIntro = val.country
      this.queryInfo.companyProvince = val.province
      if (val.city != '北京' && val.city != '天津' && val.city != '上海' && val.city != '重庆') {
        this.queryInfo.companyCity = val.city
      }
      this.search()
    },
    // 排序
    handleSort(val, name) {
      // up为正序
      this.sortField = name
      switch (name) {
        case '项目进度':
          this.queryInfo.type = '011'
          this.queryInfo.columnName = 'project_schedule'
          this.priority = { ...defaultPriority }
          this.updateTime = { ...defaultUpdateTime }
          this.projectSchedule.isDownActive = !this.projectSchedule.isDownActive
          this.projectSchedule.isUpActive = !this.projectSchedule.isDownActive
          break
        case '优先级':
          this.queryInfo.type = '009'
          this.queryInfo.columnName = 'pc.code_id'
          this.projectSchedule = { ...defaultProjectSchedule }
          this.updateTime = { ...defaultUpdateTime }
          this.priority.isDownActive = !this.priority.isDownActive
          this.priority.isUpActive = !this.priority.isDownActive
          break
        case '更新时间':
          this.queryInfo.columnName = 'update_time'
          this.projectSchedule = { ...defaultProjectSchedule }
          this.priority = { ...defaultPriority }
          this.updateTime.isDownActive = !this.updateTime.isDownActive
          this.updateTime.isUpActive = !this.updateTime.isDownActive
          break
        /* case '公司名称':
          this.queryInfo.columnName = 'corporate_name'
          break
        case '职位名称':
          this.queryInfo.columnName = 'recruitment_position'
          break */
      }
      if (val === 'up') {
        this.queryInfo.order = 0
      } else {
        this.queryInfo.order = 1
      }
      this.search()
    },
    async changeProjectStatus(val, info) {
      const query = {
        id: info.id,
        projectStatus: val
      }
      const { data: result } = await updateStatus(query)
      if (result.resultCode === 200) {
        this.$message.success('修改成功')
        this.search()
        this.getCode(this.typeCode)
      } else {
        return this.$message.error('修改失败！')
      }
    },
    // 改变项目优先级
    async changePriority(val, info) {
      if (info.priority == '冻结') {
        //当前为'冻结'时
        // const { data: res } = await updateFreezeState({
        //   projectId: info.id
        // })
        // if (res.resultCode == 200) {
        info.priority = val
        const { data: result } = await updatePriority(info)
        if (result.resultCode === 200) {
          this.$message.success('修改成功')
          this.search()
        } else {
          return this.$message.error('修改失败！')
        }
        // }
        // else {
        //   return this.$message.error('修改失败！')
        // }
      } else if (info.priority != '冻结' && val == '冻结') {
        //当前不为'冻结'且选中'冻结'
        // const { data: res } = await updateFreezeState({
        //   projectId: info.id
        // })
        // if (res.resultCode == 200) {
        info.priority = val
        const { data: result } = await updatePriority(info)
        if (result.resultCode === 200) {
          this.$message.success('修改成功')
          this.search()
        } else {
          return this.$message.error('修改失败！')
        }
        // } else {
        //   return this.$message.error('修改失败！')
        // }
      } else {
        //当前不为'冻结'且选中的不是'冻结'
        info.priority = val
        const { data: result } = await updatePriority(info)
        if (result.resultCode === 200) {
          this.$message.success('修改成功')
          this.search()
        } else {
          return this.$message.error('修改失败！')
        }
      }
    },
    //选择企业名称  调接口获取职位列表
    async enterpriseNameSelect(item) {
      const { companyCode, companyName, value } = item
      this.form.companyName = companyName
      this.form.companyCode = companyCode
      const { data: res } = await getCompanyNameList({ name: value })
      if (res.resultCode === 200) {
        const obj = res.data[0] // 获取接口数据
        // 获取需要同步的数据
        const obj1 = {
          companyCode: obj.companyCode, // 企业编号
          enterpriseName: obj.companyName, // 公司名称
          companyLogo: obj.companyLogo, // 公司logo
          companyProfile: obj.companyBriefIntroduction, // 公司简介
          industry: obj.industry // 行业
        }
        this.form = Object.assign(this.form, obj1) // 浅拷贝
        this.enterpriseNameList = []
        this.currentErpriseName = value // 赋值当前选中的企业名称
        // 调接口获取职位数据
        this.positionList = []
        const { data: result } = await selectPosition({ name: value })
        if (result.resultCode === 200) {
          result.data.forEach((item) => {
            this.positionList.push({
              value: item.jobTitle
            })
          })
          // this.positionList = result.data
        }
      }
    },
    //模糊查询企业名称
    async enterpriseNameQuerySearch(str, cb) {
      if (str != '') {
        const { data: res } = await getCompanyNameList({ name: str })
        if (res.resultCode === 200) {
          res.data.forEach((item) => {
            this.enterpriseNameList.push({
              value: item.companyFullName,
              companyName: item.companyName,
              companyCode: item.companyCode
            })
          })
          cb(this.enterpriseNameList)
        } else {
          this.$message.error('查询失败！')
        }
      }
    },
    //模糊查询职位名称
    async positionListQuerySearch(str, cb) {
      if (!str) {
        // 输入框有值
        if (!this.currentErpriseName) {
          // 没有填写企业名称
          return cb([
            {
              value: '暂无数据'
            }
          ])
        } else {
          const { data: res } = await selectPosition({
            name: this.currentErpriseName,
            jobTitle: str
          })
          this.positionList = []
          if (res.resultCode === 200) {
            res.data.forEach((item) => {
              this.positionList.push({
                value: item.jobTitle
              })
            })
            let arr = []
            if (this.positionList.length > 0) {
              arr = this.positionList
            } else {
              arr = [
                {
                  value: '暂无数据'
                }
              ]
            }
            cb(arr)
          } else {
            this.$message.error('查询失败！')
          }
        }
      } else {
        let arr = []
        if (this.positionList.length > 0) {
          arr = this.positionList
        } else {
          arr = [
            {
              value: '暂无数据'
            }
          ]
        }
        cb(arr)
      }
    },
    // 企业搜索 输入值变化时
    inputChanged() {
      this.enterpriseNameList = []
      this.positionList = []
    },
    // 岗位名称 选中值发生变化时
    async positionSelect(item) {
      if (item.value !== '暂无数据') {
        const { data: res } = await selectPosition({
          name: this.currentErpriseName,
          jobTitle: item.value
        })
        if (res.resultCode === 200) {
          let obj = res.data[0]
          const obj1 = {
            positionId: obj.id, // 职位id
            positionType: obj.positionType, // 职位类型
            dutyStation: obj.dutyStation, // 工作地址-详细地址
            isAnnual: obj.isAnnual, // 月薪或者年薪0->月薪；1->年薪
            salaryRange: obj.salaryRange, // 薪资范围
            jobDescription: obj.jobDescription, // 职位描述
            area: obj.companyArea, // 工作地区 地区
            province: obj.companyProvince, // 工作省份
            city: obj.companyCity, // 工作城市
            requiredSkills: obj.requiredSkills, // 所需技能
            recruitmentPosition: obj.jobTitle //岗位名称
          }
          this.form = Object.assign(this.form, obj1)
        }
      }

      // 职位使用下拉选择时
      // let obj = {}
      // this.positionList.forEach((el) => {
      //   if (el.id == val) {
      //     obj = el
      //   }
      // })
      // const obj1 = {
      //   positionType: obj.positionType, // 职位类型
      //   dutyStation: obj.dutyStation, // 工作地址-详细地址
      //   isAnnual: obj.isAnnual, // 月薪或者年薪0->月薪；1->年薪
      //   salaryRange: obj.salaryRange, // 薪资范围
      //   jobDescription: obj.jobDescription, // 职位描述
      //   area: obj.companyArea, // 工作地区 地区
      //   province: obj.companyProvince, // 工作省份
      //   city: obj.companyCity, // 工作城市
      //   requiredSkills: obj.requiredSkills, // 所需技能
      //   recruitmentPosition: obj.jobTitle //岗位名称
      // }
      // this.form = Object.assign(this.form, obj1)
    },
    // 添加项目 弹框显示
    addProjectDialog() {
      this.addProjectDialogShow = true
      this.currentErpriseName = ''
      this.positionList = []
    },
    // 添加项目 保存按钮
    addProject() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const { data: res } = await saveProject(this.form)
          if (res.resultCode == 200) {
            this.$message.success('添加成功')
            this.addProjectDialogShow = false
            //成功后跳转到新增项目界面
            this.$router.push({
              path: '/businessManagement/projectCenter/addProject',
              query: {
                id: res.data
              }
            })
          }
        } else {
          return false
        }
      })
    },
    closeAddDialog() {
      this.form = { ...defaultForm }
      this.currentErpriseName = ''
      this.positionList = []
    },
    //成功过后手动将文件添加到展示列表里  3月20日删除上传
    /* uploadFile(file) {
      if (file.file) {
        this.fileList.push(file.file)
      }
    }, */
    //删除上传的文件
    /* handleCloseUpload(i) {
      this.fileList.splice(i, 1)
      this.form.file = []
    }, */
    // 跳转到详情页面
    clickToDetails(item) {
      // /projectCenter/selectProjectBYId
      const userPermissions = JSON.parse(sessionStorage.getItem('menuTree')).flatMap(
        (outerItem) => {
          return outerItem.children.map((item) => item.path)
        }
      )
      const hasPermission = userPermissions.includes('/projectCenter/selectProjectBYId')
      if (hasPermission) {
        this.$router.push({
          path: '/businessManagement/projectCenter/addProject',
          query: {
            id: item.id
          }
        })
      } else {
        this.$message.warning('暂无权限')
      }
    },
    /* handleControl(val, info) {
      if (val === '删除') {
        this.id = info.id
        this.deleteItem(info.id)
      } else if (val === '目标企业') {
        this.id = info.id
        this.searchTargetEnterprise()
      } else if (val === '添加') {
        this.submitTargetEnterprise()
      } else if (val === '取消') {
        this.cancelTargetEnterprise(info.enterpriseId)
      } else {
        let name = ''
        switch (val) {
          case '话术管理':
            name = 'OperationManagement'
            break

          case '候选人':
            name = 'Candidate'
            break

          case '项目记录':
            name = 'projectRecord'
            break

          default:
            break
        }
        this.$router.push({
          name,
          query: {
            ...info,
            searchInfo: JSON.stringify(this.queryInfo)
          }
        })
      }
    }, */
    /* deleteItem(val) {
      this.$confirm('此操作不可撤回，请谨慎删除', '提示')
        .then(async () => {
          const { data: res } = await deleteProjectCenter([val])
          if (res.resultCode === 200) {
            this.$message.success('删除成功')

            this.search()
          }
        })
        .catch(() => {})
    }, */
    /* viewItem(id) {
      this.$router.push({
        name: 'ViewProject',
        query: {
          id,
          searchInfo: JSON.stringify(this.queryInfo)
        }
      })
    }, */
    // 添加目标企业
    /* async submitTargetEnterprise() {
      const { data: res } = await addTargetEnterprise({
        enterpriseId: this.enterpriseObj.companyCode,
        projectId: this.id
      })
      if (res.resultCode === 200) {
        this.$message.success('添加目标企业成功')
        this.enterprise = ''
        this.isShowEnterprise = false
        this.enterpriseObj = {}

        this.searchTargetEnterprise()
      }
    }, */
    // 弹窗关闭
    /* handleClose() {
      this.dialogVisible = false
      this.enterprise = ''
      this.enterpriseObj = {}
      this.isShowEnterprise = false
    }, */
    // 取消已添加的企业
    /* cancelTargetEnterprise(id) {
      this.$confirm('此操作不可撤回，请谨慎操作', '提示')
        .then(async () => {
          const { data: res } = await deleteTargetEnterprise({ id })
          if (res.resultCode === 200) {
            this.$message.success('取消成功')
            this.searchTargetEnterprise()
          }
        })
        .catch(() => {})
    }, */
    // 监听优先级改变 val为选中的值，info.priority为选中前的值

    // 修改客户经理
    async modifyCustomerManager(val) {
      if (this.roleId == 1) {
        this.customerManagerDialogForm = true
        this.customerManagerForm.manager = val.customerManagers
        const res = await updategetCustomerManager(this.customerManagerForm)
        this.customerManagerList = res.data.data
        this.customerManagerForm.projectId = val.id
      } else {
        this.$message.error('没有修改权限！')
      }
      // console.log(val.customerManagers);
    },
    // 发送修改请求
    async modifyApiCustomerManager() {
      const { data: res } = await selectUpdateCustomerManager(this.customerManagerForm)
      if (res.resultCode == 200) {
        this.customerManagerDialogForm = false
        this.$message.success('修改成功！')
        this.search()
      } else {
        this.$message.error('修改失败！')
      }
    },

    // 清空项目搜索框
    cleanSearch(val) {
      if (val == '') this.search()
    },

    // 清空人选搜索框 cleanQuerySearch
    cleanQuerySearch(val) {
      if (val == '') this.selectPersonChosen()
    }
  }
}
</script>

<style lang="less" scoped>
.mr-r-10 {
  margin-right: 10px;
}

.project_center {
  width: 100%;
  height: 100%;

  .candidates_flex {
    display: flex;
    width: 120px;
    justify-content: space-between;
    padding-left: 20px;
    position: relative;
    top: -10px;

    .left_active {
      border-bottom: 2px solid #079992;
      cursor: pointer;
    }

    .left {
      color: #8c8787;
      cursor: pointer;
    }
  }
}

/deep/ .el-card__body {
  padding: 16px;
}

/deep/ .el-form-item {
  margin-bottom: 5px;
}

.war-message {
  z-index: 3000 !important;
}

.mini-select {
  max-width: 80px !important;
}

.container {
  // height: calc(100% - 52px);
  height: 80.5vh;
  overflow: scroll;
}

.pagination {
  width: 100%;
  text-align: center;
  // margin-top: 10px;
  // margin: 10px 0 20px 0;
}

.labelStyle {
  .project_type {
    display: flex;
    max-height: 40px;

    .type_item {
      padding: 0px 10px;
      cursor: pointer;
      color: #333333;
      height: 32px;
      line-height: 32px;
      margin-right: 10px;
    }
  }

  .pitch {
    border: 1px solid #17757a;
    border-radius: 4px;
    color: #17757a !important;
  }
}

.page_nation {
  width: 100%;
  // overflow: auto;

  .green_back {
    background: #48dc5f;
    width: 46px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    color: #fff;
    border-radius: 9px;
    display: inline-block;
  }

  .yellowbg {
    background: #ffa24d;
  }

  .redbg {
    background: #ff4d4d;
  }

  .bluebg {
    background: #24b6f4;
  }

  .huibg {
    background: #999999;
  }
  .success {
    background: #18238a;
  }

  .row {
    display: flex;
    justify-content: center;

    .row_css {
      color: #17757a;
      margin-right: 10px;
      cursor: pointer;
    }

    .row_red {
      color: #fa5050;
      cursor: pointer;
    }
  }

  .contentStyle {
    width: 100%;
    display: flex;
    // align-items: center;
    justify-content: left;
    margin-bottom: 12px;
    background: #fff;
  }

  .contentStyle:hover {
    .enterprise .enterprise_title {
      color: #17757a !important;
    }
  }
}

.content_left {
  display: flex;
  width: 50%;
  min-width: 50%;

  .color1 {
    display: flex;
    align-items: center;
    text-align: center;
    background-color: #0ea4e7 !important;
  }

  .color2 {
    text-align: center;
    word-wrap: break-word;
    box-sizing: border-box;
    padding-top: 10px;
    background-color: #ffbe76 !important;
  }

  .color3 {
    display: flex;
    align-items: center;
    text-align: center;
    background-color: #7ed6df !important;
  }

  .color4 {
    text-align: center;
    word-wrap: break-word;
    box-sizing: border-box;
    padding-top: 21px;
    background-color: #4fc3f7 !important;
  }

  .color5 {
    display: flex;
    align-items: center;
    text-align: center;
    background-color: #c14ef3 !important;
  }

  .color6 {
    display: flex;
    align-items: center;
    text-align: center;
    background-color: #26bf56 !important;
  }

  .color7 {
    display: flex;
    align-items: center;
    text-align: center;
    background-color: #809fb8 !important;
  }

  .color8 {
    display: flex;
    align-items: center;
    text-align: center;
    background-color: #ababab !important;
  }

  .color9 {
    display: flex;
    align-items: center;
    text-align: center;
    background-color: #079992 !important;
  }

  .color10 {
    display: flex;
    align-items: center;
    text-align: center;
    background-color: #f6e58d !important;
  }

  .color11 {
    display: flex;
    align-items: center;
    text-align: center;
    background-color: #ff7979 !important;
  }

  .color12 {
    text-align: center;
    word-wrap: break-word;
    box-sizing: border-box;
    padding-top: 21px;
    background-color: #badc58 !important;
  }

  .color13 {
    text-align: center;
    word-wrap: break-word;
    box-sizing: border-box;
    padding-top: 21px;
    background-color: #6ab04c !important;
  }

  .schedule {
    width: 30px;
    // height: 100%;
    height: 126px;
    background-color: skyblue;
    color: #fff;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    // text-align: center;
    // word-wrap: break-word;
  }

  .primary {
    padding: 22px 0 22px 15px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    // border: 1px solid red;
    // padding: 22px 0 0 15px;
    .time {
      display: flex;
      flex-flow: row wrap;
      font-size: 14px;
      color: #999999;
      // margin-top: 10px;
    }

    width: 80%;

    .enterprise {
      display: flex;
      justify-content: left;
      width: 100%;
      margin-right: 20px;

      .enterprise_title {
        width: 280px;
        max-width: 280px;
        font-size: 18px;
        font-weight: 700;
        color: #333333;
        cursor: pointer;
        margin-right: 10px;
      }

      .tag {
        width: 34px;
        padding: 0px 10px;
        height: 20px;
        border-radius: 4px;
        border: 1px solid #17757a;
        color: #17757a;
        font-size: 14px;
        margin-left: 10px;
        box-sizing: border-box;
        // margin: 0 34px 0 14px;
      }

      .imageBox {
        display: flex;
        align-items: center;

        img {
          width: 24px;
          height: 24px;
          border-radius: 2px;
          margin-right: 9px;
        }

        .box {
          // 对齐用
          width: 24px;
          height: 24px;
          border-radius: 2px;
          margin-right: 9px;
        }

        .img_txt {
          display: inline-block;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          max-width: 160px;
          font-size: 14px;
          color: #333333;
        }
      }
    }

    .recommend_interview_Number {
      display: flex;

      // margin-top: 40px;
      .recommend {
        display: flex;
        align-items: center;
        // justify-content: space-between;
        background-color: #f7f7f7;
        border-radius: 4px;
        color: #333333;
        font-size: 14px;
        padding: 2px 10px;
        margin-right: 18px;

        @media (max-width: 1366px) {
          .text {
            font-size: 12px !important;
          }
        }

        .line {
          width: 1px;
          height: 10px;
          background-color: #c4c4c4;
          margin: 0 7px;
        }
      }
    }
  }
}

.content_right {
  display: flex;
  justify-content: space-around;
  padding: 22px 0;

  .manager {
    margin-right: 40px;

    .project_manager {
      display: flex;
      align-items: center;
      // margin-top: 8px;
      margin-bottom: 10px;

      .label {
        width: 75px;
        color: #333333;
        font-size: 14px;
      }

      .value {
        display: flex;
        flex-flow: row wrap;
        justify-content: left;
        width: 100px;

        span {
          color: #333333;
          font-size: 14px;
          margin-right: 5px;
        }
      }
    }

    .customer_manager {
      display: flex;
      flex-flow: row nowrap;
      justify-content: left;

      .label {
        width: 75px;
        color: #333333;
        font-size: 14px;
      }

      span {
        color: #333333;
        font-size: 14px;
      }
    }
  }

  .operation {
    // width: 235px;
    // margin-right: 30px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    padding-right: 30px;
    box-sizing: border-box;
    text-align: right;

    .new_time {
      font-size: 12px;
      color: #999999;
    }

    .operating_button {
      margin-top: 25px;
      display: flex;

      .btn_box {
        width: 80px;
        height: 28px;
        text-align: center;
        line-height: 28px;
        font-size: 14px;
        border-radius: 4px;
        cursor: pointer;
      }

      .workbench {
        border: 1px solid #17757a;
        color: #17757a;
      }

      .normal {
        border: 1px solid #999;
        color: #999;
      }

      .red {
        border: 1px solid #ff371c;
        color: #ff371c;
      }

      .freeze {
        border: 1px solid #999999;
        color: #999999;
      }
    }
  }
}

.level {
  height: 32px;
  display: flex;
  align-items: center;
  margin-right: 40px;

  /deep/.el-input__inner {
    height: 32px;
    line-height: 32px;
  }

  /deep/.el-input__icon {
    line-height: 32px;
  }
}

.enterporise_list_input_add {
  display: flex;
  flex-direction: row;
  align-items: center;

  .left {
    display: flex;
    min-width: 30%;
  }
}

.enterporise_list_input_add .right {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-left: auto;
  margin-right: 200px;

  .add_enterprise {
    background-color: #17757a;
    border-color: #17757a;
  }
}

.project_manager_search {
  display: flex;
  align-items: center;
  margin-left: 50px;

  .project_manager {
    margin-right: 10px;
    text-align: center;
    min-width: 64px;
  }

  /deep/.el-select {
    min-width: 100px;
  }
}

.input_new {
  margin-left: 40px;
  margin-right: 20px;
  min-width: 140px;

  /deep/ .el-button {
    border-radius: 0 4px 4px 0;
    height: 40px;
  }

  /deep/ .el-button--default {
    background-color: #17757a;

    i {
      color: #fff;
    }
  }
}

.elPagination {
  padding: 20px;
  text-align: right;
}

.search-input {
  width: 60%;

  /deep/ .el-input-group__append {
    background: #17757a;
    color: #fff;
    border: 1px solid #17757a;
  }
}

.search-enterprise {
  padding-bottom: 10px;
  border-bottom: 1px solid #333333;
}

.enterpriseInfo {
  display: flex;
  align-items: center;
  padding: 15px 0;
  justify-content: space-between;

  .left {
    display: flex;
  }

  .info {
    padding: 4px 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .companyFullName {
      font-size: 16px;
      color: #333333;
    }

    .industry {
      display: flex;
      font-size: 12px;
      color: #8a8a8a;

      .area {
        position: relative;
        margin-left: 20px;

        .line {
          color: #c4c4c4;
          position: absolute;
          top: -1px;
          left: -10px;
        }
      }
    }
  }
}

/* .hasAddEnterprise {
  p {
    color: #333333;
    font-weight: 700;
    padding: 10px 0;
    font-size: 14px;
    border-bottom: 1px solid #e5e5e5;
  }
  .targetEnterprise {
    border-bottom: 1px solid #e5e5e5;
    .right {
      display: flex;
    }
  }
} */
.add_project_dialog {
  .title {
    display: flex;

    .line {
      width: 4px;
      height: 20px;
      border-radius: 4px;
      background-color: #17757a;
      margin-right: 8px;
    }

    .title_txt {
      font-weight: 600;
      color: #333333;
    }
  }

  .dialog-footer {
    .button_box {
      display: flex;
      justify-content: center;
      font-size: 12px;

      .add {
        width: 64px;
        height: 33px;
        border-radius: 4px;
        background-color: #17757a;
        color: #fff;
        margin-right: 34px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }

      .cancel {
        width: 64px;
        height: 33px;
        border-radius: 4px;
        border: 1px solid #17757a;
        display: flex;
        align-items: center;
        color: #17757a;
        justify-content: center;
        cursor: pointer;
      }
    }
  }
}

.add_project_manager {
  /deep/.el-icon-close {
    right: -5px !important;
    top: 0 !important;
  }
}

.block_flex {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #17757a;
  position: relative;
  top: -2px;
  left: -4px;
}

.candidateRemarks {
  width: 320px;
}

.candidateRemarks_txt {
  display: inline-block;
  width: 320px;
  color: #212121 !important;
  white-space: nowrap;
  /* 不换行 */
  overflow: hidden;
  /* 超出部分隐藏 */
  text-overflow: ellipsis;
  /* 用省略号表示超出部分 */
}

/deep/ .add_project_dialog .el-form-item__content {
  margin-bottom: 10px;
}

/deep/ .add_project_form .el-select {
  width: 80%;
}

/deep/ .add_project_form .el-autocomplete {
  width: 80%;
}

/deep/ .add_project_form .el-input {
  width: 80%;
}
.buttonContent {
  display: flex;
}

/deep/ .el-checkbox-button__inner {
  border: 1px solid #fff !important;
}

/deep/ .el-checkbox-button.is-checked .el-checkbox-button__inner {
  border: 1px solid #17757a !important;
  background-color: #fff;
  color: #17757a;
}

/deep/ .el-checkbox-button__inner:hover {
  color: #17757a;
}

/deep/.el-checkbox-button__inner {
  padding: 9px 10px;
}

// /deep/ .el-checkbox-button.is-focus .el-checkbox-button__inner{
//     border-color:#17757A !important
// }
/deep/ .el-checkbox-button.is-checked .el-checkbox-button__inner {
  box-shadow: none;
}

.openClose {
  display: flex;
  justify-content: space-between;
  .openButton {
    width: 10%;
    line-height: 30px;
    color: #1e9fff;
    cursor: pointer;
    text-align: center;
  }
}
.openInfo {
  width: 90%;
  max-height: 40px;
  overflow: hidden;
  // transition: all 1s linear;
}
.newClass {
  width: 90%;
  max-height: 400px;
  overflow: auto;
  transition: all 1s linear;
}
/deep/ .el-radio-button__inner {
  border: 1px solid #fff !important;
  padding: 9px 10px;
}
/deep/ .el-radio-button__inner:hover {
  color: #17757a;
}
/deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background-color: #fff;
  color: #17757a;
  border: 1px solid #17757a !important;
  box-shadow: none;
}
/deep/ .el-radio-button.is-checked .el-radio-button__inner {
  box-shadow: none;
}

/* 媒体查询：自适应 */
// 1680x1050 (1680x889)
@media (max-width: 1682px) and (max-height: 890px) {
  .container {
    max-height: 81vh !important;
  }
}

// 1600x900 (1600x739)
@media (max-width: 1602px) and (max-height: 740px) {
  .container {
    max-height: 76vh !important;
  }
}

// 1366x768 (1366x607)
@media (max-width: 1368px) and (max-height: 608px) {
  .container {
    max-height: 71vh !important;
  }
}

// 1280x960 (1280x799)
@media (max-width: 1282px) and (max-height: 800px) {
  .container {
    max-height: 78vh !important;
  }
}

// 1280x800 (1280x639)
@media (max-width: 1282px) and (max-height: 640px) {
  .container {
    max-height: 72vh !important;
  }
}

// 1280x768 (1280x607)
@media (max-width: 1282px) and (max-height: 608px) {
  .container {
    max-height: 71vh !important;
  }
}

// 1280x720 (1280x599)
@media (max-width: 1282px) and (max-height: 600px) {
  .container {
    max-height: 69vh !important;
  }
}

// 1280x600 (1280x439)
@media (max-width: 1282px) and (max-height: 440px) {
  .container {
    max-height: 60vh !important;
  }
}

// 1152x864 (1152x703)
@media (max-width: 1153px) and (max-height: 704px) {
  .container {
    max-height: 75vh !important;
  }
}

// 1024x768 (1024x607)
@media (max-width: 1025px) and (max-height: 608px) {
  .container {
    max-height: 71vh !important;
  }
}

// 800x600 (800x439)
@media (max-width: 801px) and (max-height: 440px) {
  .container {
    max-height: 60vh !important;
  }
}
</style>
